/* eslint-disable react-hooks/exhaustive-deps */
import { TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    createComponentValue as createComponentValueAction,
    fetchMaintenanceIssue as fetchMaintenanceIssueAction,
} from '../../../../../../../../actions/collections/maintenanceIssues';

function TextComponent({
    disabled,
    fetchMaintenanceIssue,
    id,
    issueId,
    itemId,
    component,
    createComponentValue,
}) {
    const [textValue, setTextValue] = useState(component.value);
    const [error, setError] = useState(false);
    const { inputMin, inputMax } = component;
    const { formatMessage } = useIntl();

    const initialRender = useRef(true);
    useEffect(() => {
        (async () => {
            if (initialRender.current) {
                initialRender.current = false;
            } else if (textValue !== null) {
                await createComponentValue({
                    body: {
                        componentId: component.id,
                        value: textValue,
                    },
                    issueId,
                    itemId,
                });
                fetchMaintenanceIssue({ id: issueId });
            }
        })();
    }, [createComponentValue, textValue, issueId, itemId, component.id]);

    const props =
        component.inputType === 'NUMBER'
            ? {
                  error,
                  helperText:
                      error &&
                      formatMessage(
                          {
                              defaultMessage: 'Enter a number between {min} and {max}',
                              id: 'maintenance.plan.module.item.inputRangeHelper',
                          },
                          {
                              max: inputMax,
                              min: inputMin,
                          }
                      ),
                  inputProps: {
                      max: inputMax,
                      min: inputMin,
                  },
                  onBlur: ({ target }) => {
                      if (target.value > inputMax || target.value < inputMin) {
                          setError(true);
                      } else {
                          setError(false);
                          setTextValue(target.value);
                      }
                  },
                  onKeyPress: ({ key, target }) => key === 'Enter' && target.blur(),
                  type: 'number',
              }
            : {
                  maxRows: 5,
                  minRows: 1,
                  multiline: true,
              };

    return (
        <TextField
            defaultValue={textValue}
            disabled={disabled}
            fullWidth
            id={`${id}Value`}
            label={component.title}
            name="value"
            onBlur={({ target }) => setTextValue(target.value)}
            {...props}
        />
    );
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createComponentValue: createComponentValueAction,
            fetchMaintenanceIssue: fetchMaintenanceIssueAction,
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(TextComponent);
